import { render, staticRenderFns } from "./Epgs.vue?vue&type=template&id=22708424"
import script from "./Epgs.vue?vue&type=script&lang=js"
export * from "./Epgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports